import axios from 'axios'
import axiosRetry from 'axios-retry'

const pathForCameraData = filename => {
  if (ENV === 'development') return '/data.json'
  else if (EXPORT) return window.location.href.replace('index.html', `${filename}.json`)
  else return `/${filename}.json`
}

export function getCameraData(filename) {
  const client = axios.create()

  axiosRetry(client, {
    retries: 4,
    retryCondition: axiosRetry.isRetryableError,
    retryDelay: axiosRetry.exponentialDelay
  })

  return client
    .get(pathForCameraData(filename))
    .then(r => r.data)
}



// WEBPACK FOOTER //
// ./src/api/getCameraData.js